import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FilterCriteria {
  timeRange?: { start: Date; end: Date };
  componentIds?: string[];
  eventSources?: string[];
}

export interface UIState {
  selectedComponents: string[];
  selectedConnections: string[];
  activeTab: string | null;
  filterCriteria: FilterCriteria;
}

const initialState: UIState = {
  selectedComponents: [],
  selectedConnections: [],
  activeTab: null,
  filterCriteria: {},
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setSelectedComponents: (state, action: PayloadAction<string[]>) => {
      state.selectedComponents = action.payload;
    },
    setSelectedConnections: (state, action: PayloadAction<string[]>) => {
      state.selectedConnections = action.payload;
    },
    setActiveTab: (state, action: PayloadAction<string | null>) => {
      state.activeTab = action.payload;
    },
    updateFilterCriteria: (state, action: PayloadAction<Partial<FilterCriteria>>) => {
      state.filterCriteria = { ...state.filterCriteria, ...action.payload };
    },
    resetFilterCriteria: (state) => {
      state.filterCriteria = {};
    },
    resetUI: (state) => {
      state.selectedComponents = [];
      state.selectedConnections = [];
      state.activeTab = null;
      state.filterCriteria = {};
    },
  },
});

export const {
  setSelectedComponents,
  setSelectedConnections,
  setActiveTab,
  updateFilterCriteria,
  resetFilterCriteria,
  resetUI,
} = uiSlice.actions;

export default uiSlice.reducer;
